import TenantsContent from "./TenantsContent";

export default TenantsContent;
